import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class CloseTrashView extends Action<StorymapState> {
    public static ACTION_TYPE = 'CloseTrashView';

    public constructor() {
        super(CloseTrashView.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    state.trashState.rows = [];
    state.trashState.selectedRowId = null;
    state.trashState.isLoading = false;
    state.trashState.loadError = '';
    state.trashState.isRowOperationInProgress = false;
    state.trashState.isEmptying = false;
    state.trashState.trashLoadToken++;
    state.trashState.rowOperationToken++;
    state.trashState.emptyOperationToken++;
    state.trashState.isDialogOpen = false;
};

//@ts-ignore
registerReducer(CloseTrashView.ACTION_TYPE, reducer);
